<script>
/* COMPOSANTS */
import AkInputTextArea from '@components/v2/input/AkInputTextArea';
import AkFicForm from '@components/v2/general/AkFicForm.vue';

/* MIXINS */
import utilsMixin from '@mixins/utilsMixin';

/* SERVICES */

export default {
  inject: {
    pSubmitted: {default: null},
    pDisabled: {default: null},
    pIgnoredValidator: {default: null},
  },
  components: {AkFicForm, AkInputTextArea},
  mixins: [utilsMixin],
  props: {
    modelValue: {
      required: true,
    },
    index: {
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    ficType: {
      type: String,
      required: true,
    },
    fromAccommodation: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['delete', 'update'],
  data() {
    return {};
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
    indexDisplay() {
      return this.index + 1;
    },
    ref() {
      return 'stepInfo-' + this.index;
    },
  },
  methods: {
    doDelete() {
      this.$emit('delete');
    },
  },
  watch: {
    currentValue: {
      handler: function (val) {
        if (this.currentValue.status !== 'toDelete') this.$emit('update', this.currentValue);
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div class="flex items-center gap-2">
    <i
      class="ga-icon ga-chevron_down text-grey-900 text-2xl md:hover:cursor-pointer"
      @click="toggleElement90(this.$refs, this.ref, $event)" />
    <div class="flex justify-between items-center w-full">
      <span class="text-grey-900 font-semibold text-lg">Etape {{ indexDisplay }}</span>
      <i
        class="ga-icon ga-trash text-red cursor-pointer text-2xl"
        v-if="!this.pDisabled && this.canDelete"
        @click="doDelete()"></i>
    </div>
  </div>
  <div class="flex flex-col md:gap-4 gap-2" :ref="this.ref">
    <div class="flex flex-col gap-2">
      <AkFicForm
        v-model="this.currentValue.fic"
        :validator="this.validator.fic"
        choose-label="Ajouter une photo"
        :required="false"
        :disabled="pDisabled"
        :ficPreview="fromAccommodation"
        accept=".jpg,.jpeg,.png"
        :fic-type="this.ficType"
        title="Photo"
        :table-id="this.currentValue.id"
        table-name="onboarding_step_info" />

      <AkInputTextArea
        v-model="this.currentValue.description"
        :validator="this.validator.description"
        label="Commentaire" />
    </div>
  </div>
</template>
